import moment from "jalali-moment";

const actionTypeMap = {
  create: { name: "ایجاد", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300" },
  update: { name: "ویرایش", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300" },
  delete: { name: "حذف", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300" },
  view: { name: "مشاهده", color: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300" },
  login: { name: "ورود", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300" },
  logout: { name: "خروج", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300" },
  export: { name: "خروجی", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300" },
};

export default function AdminActivityCard({ data }) {
  const actionInfo = actionTypeMap[data.action] || { name: data.action, color: "bg-gray-100 text-gray-800" };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 mb-3">
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${actionInfo.color}`}>
              {actionInfo.name}
            </span>
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300">
              {data.entity}
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">ادمین</p>
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                {data.adminName || "نامشخص"}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">موبایل</p>
              <p className="text-sm font-medium text-gray-900 dark:text-white direction-ltr text-right">
                {data.adminMobile}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">IP</p>
              <p className="text-sm font-medium text-gray-900 dark:text-white direction-ltr text-right">
                {data.ip}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">تاریخ و ساعت</p>
              <p className="text-sm font-medium text-gray-900 dark:text-white">
                {moment(data.createdAt).utcOffset("+03:30").locale("fa").format("jYYYY/jMM/jDD - HH:mm:ss")}
              </p>
            </div>

            {data.entityId && (
              <div className="md:col-span-2">
                <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">شناسه موجودیت</p>
                <p className="text-sm font-medium text-gray-900 dark:text-white font-mono">
                  {data.entityId}
                </p>
              </div>
            )}
          </div>

          <div className="mb-3">
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">توضیحات</p>
            <p className="text-sm text-gray-700 dark:text-gray-300">
              {data.description}
            </p>
          </div>

          {data.changes && (
            <details className="mt-3">
              <summary className="cursor-pointer text-xs text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300">
                مشاهده تغییرات
              </summary>
              <div className="mt-2 p-3 bg-gray-50 dark:bg-gray-900 rounded-md">
                <pre className="text-xs text-gray-700 dark:text-gray-300 overflow-x-auto">
                  {JSON.stringify(JSON.parse(data.changes), null, 2)}
                </pre>
              </div>
            </details>
          )}

          {data.userAgent && (
            <div className="mt-3">
              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                User-Agent: {data.userAgent}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
